import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LogoLink from './LogoLink';
import { useAuth } from '../context/AuthContext';


const ThankYou: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isGift = searchParams.get('isGift') === 'true';
  const { user, refreshBalance } = useAuth();


  return (
    <div className="thank-you-page">
      <div className="container">
        <div className="thank-you-content">
          <LogoLink className="navbar-brand mb-4" />
          <h1 className="thank-you-heading mt-3">Thank You!</h1>
          <p className="thank-you-message">
            {isGift 
              ? 'Gift purchased successfully! The credits are scheduled to be sent by email on your selected time and date.'
              : 'Operation completed successfully! Enjoy your race!'
            }
          </p>
          {user &&
          <button 
            className="btn btn-primary mt-2 me-2" 
            onClick={async () => {
              await refreshBalance();
              navigate('/booking');
            }}
          >
            Go to Booking
          </button>}
          <button 
            className="btn btn-primary mt-2 me-2" 
            onClick={async () => {
              await refreshBalance();
              navigate('/dashboard');
            }}
          >
            Go to Dashboard
          </button>

        </div>
      </div>
    </div>
  );
};

export default ThankYou;


